import type { SVGProps } from "react";
export default function SvgBrainFull(props: SVGProps<SVGSVGElement>) {
	return (
		<svg
			xmlns="http://www.w3.org/2000/svg"
			width="1em"
			height="1em"
			fill="none"
			stroke="currentColor"
			strokeLinecap="round"
			strokeLinejoin="round"
			strokeWidth={2}
			className="lucide lucide-brain"
			viewBox="0 0 24 24"
			{...props}
		>
			<path d="M12 18V5" />
			<path d="M15 13a4.17 4.17 0 0 1-3-4 4.17 4.17 0 0 1-3 4" />
			<path d="M17.598 6.5A3 3 0 1 0 12 5a3 3 0 1 0-5.598 1.5" />
			<path d="M17.997 5.125a4 4 0 0 1 2.526 5.77" />
			<path d="M18 18a4 4 0 0 0 2-7.464" />
			<path d="M19.967 17.483A4 4 0 1 1 12 18a4 4 0 1 1-7.967-.517" />
			<path d="M6 18a4 4 0 0 1-2-7.464" />
			<path d="M6.003 5.125a4 4 0 0 0-2.526 5.77" />
		</svg>
	);
}
